import React from 'react';
import { useNavigate } from 'react-router-dom';
import PrivacyPolicy from '../components/PrivacyPolicy';
import PieLegal from '../components/PieLegal';
import './legal.css';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="pagina-legal">
      <header className="legal-encabezado">
        <div className="legal-encabezado-interior">
          {/* `navigate(-1)` y no una ruta fija: acá se llega desde el registro,
              desde el onboarding y desde el pie de la landing, y volver al
              lugar equivocado obliga a rehacer el camino. */}
          <button className="legal-volver" onClick={() => navigate(-1)}>
            ← Volver
          </button>
          <div>
            <h1>Privacidad</h1>
            <p>Qué datos usamos y para qué</p>
          </div>
        </div>
      </header>

      <PrivacyPolicy />
      <PieLegal />
    </div>
  );
};

export default PrivacyPolicyPage;
